module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div>\n    <h1 id="xInviteModalHeader">'+
((__t=( title ))==null?'':__t)+
'</h1>\n    <p tabindex="0" id="xInviteModalContent">'+
((__t=( msg ))==null?'':_.escape(__t))+
'</p>\n</div>';
}
return __p;
};
